<template>
    <div>
        <h5 style="margin-top: 10px;font-weight: bold;font-size: 14px;">
            {{ title }}
        </h5>
        <div style="background-color: #f5f7fa;padding: 10px;border-radius: 4px; margin-top: 10px;" v-for="(item, index) in list" :key="index">
            <p>{{ item.app }}</p>
            <p>{{ item.unique_app }}</p>
            <p style="padding-left: 1rem;">投放账户<span style="color: #ff0000;">（拥有产品投放的账户权限，即可使用该产品、账户权限请联系组长绑定或授权）</span></p>
            <p style="padding-left: 1rem;" v-for="(itema, indexa) in item.account" :key="indexa">{{ itema }}</p>
        </div>
    </div>
</template>
<script>
export default {
    name: 'AuthItems',
    props: {
        title: {
            type: String,
            default: '重复类型：与媒体产品重复'
        },
        list: {
            type: Array,
            default: () => [
                // {
                //     "app": "录入产品：OPPO-com.topten.pxds.nearme.gamecenter（ID：排序大师）（包名：32725275）",
                //     "unique_app": "重复产品：OPPO-排序大师（ID：32725275）（包名：com.topten.pxds.nearme.gamecenter）",
                //     "account": [
                //         "账户：(1000396294)深圳市千石互联科技有限公司-mjxzOPPO07-nobid",
                //         "账户：(1000458725)深圳市千石互联科技有限公司-mjxzOPPO38-展示优选",
                //         "账户：(1000474705)深圳市千石互联科技有限公司-mjxzOPPO71-商店关键行为",
                //         "账户：(1000481459)深圳市千石互联科技有限公司-mjxzOPPO80-CostCapROI14",
                //         "账户：(1000481468)深圳市千石互联科技有限公司-mjxzOPPO84",
                //         "账户：(1000481471)深圳市千石互联科技有限公司-mjxzOPPO85",
                //         "账户：(1000493857)深圳市千石互联科技有限公司-mjxzOPPO97",
                //         "账户：(1000493860)深圳市千石互联科技有限公司-mjxzOPPO100-costcap激活"
                //     ]
                // }
            ]
        }
    }
}
</script>